var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Search as SearchIcon } from '../../svgs';
export function SearchButton(_a) {
    var setCurrentDropDown = _a.setCurrentDropDown, overrideSearch = _a.overrideSearch, setIsSearching = _a.setIsSearching;
    if (overrideSearch && setIsSearching) {
        return (_jsx("div", __assign({ id: 'search-button', className: "button", onClick: function () {
                setIsSearching(true);
                setCurrentDropDown(null);
            } }, { children: _jsx("button", __assign({ className: 'quiet', "aria-label": 'search', onClick: function () {
                    setIsSearching(true);
                    setCurrentDropDown(null);
                } }, { children: _jsx(SearchIcon, {}, void 0) }), void 0) }), void 0));
    }
    else {
        return (_jsx(Link, __assign({ to: '/network-search' }, { children: _jsx("div", __assign({ id: 'search-button', className: "button", onClick: function () {
                    setCurrentDropDown(null);
                } }, { children: _jsx("button", __assign({ className: 'quiet', "aria-label": 'search', onClick: function () {
                        setCurrentDropDown(null);
                    } }, { children: _jsx(SearchIcon, {}, void 0) }), void 0) }), void 0) }), void 0));
    }
}
